import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SuperadminLayout, { DarkCard } from "./SuperadminLayout";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Warning } from "@phosphor-icons/react";

export default function SuperadminMaintenance() {
  const [enabled, setEnabled] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/superadmin/maintenance");
        setEnabled(!!data.enabled);
        setMessage(data.message || "");
      } finally { setLoading(false); }
    })();
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/superadmin/maintenance", { enabled, message });
      toast.success(enabled ? "Mode maintenance activé" : "Mode maintenance désactivé");
    } catch (e) { toast.error(e?.response?.data?.detail || "Échec"); }
    finally { setSaving(false); }
  };

  if (loading) return <SuperadminLayout title="Maintenance"><p className="text-[#8494A8]">Chargement…</p></SuperadminLayout>;

  return (
    <SuperadminLayout title="Mode maintenance">
      <DarkCard className="p-8" data-testid="maintenance-panel">
        <div className="flex items-start gap-4 mb-6 p-4 bg-amber-500/10 border border-amber-500/30 rounded-xl">
          <Warning size={24} weight="duotone" className="text-amber-400 shrink-0" />
          <div className="text-sm text-[#B7C4D6]">
            <p className="text-amber-300 font-semibold mb-1">Impact immédiat</p>
            Quand activé, tous les utilisateurs (sauf superadmins) recevront un message de maintenance et les écritures API seront bloquées. Utilisez pour les mises à jour majeures.
          </div>
        </div>

        <div className="flex items-center justify-between mb-6 p-4 bg-[#081221] rounded-xl border border-white/10">
          <div>
            <p className="text-white font-medium">Mode maintenance</p>
            <p className="text-xs text-[#8494A8] mt-1">{enabled ? "🔴 Actif — plateforme fermée aux utilisateurs" : "🟢 Inactif — plateforme accessible normalement"}</p>
          </div>
          <Switch checked={enabled} onCheckedChange={setEnabled} data-testid="maintenance-toggle" />
        </div>

        <div>
          <label className="text-xs uppercase tracking-widest text-[#8494A8] mb-2 block">Message affiché aux utilisateurs</label>
          <Textarea
            value={message} onChange={(e) => setMessage(e.target.value)}
            rows={4} maxLength={500}
            placeholder="Ex: Maintenance planifiée jusqu'à 22h. Vos données sont en sécurité."
            className="bg-[#081221] border-white/10 text-white placeholder:text-[#5F758F]"
            data-testid="maintenance-message"
          />
          <p className="text-xs text-[#8494A8] mt-1">{message.length}/500</p>
        </div>

        <div className="mt-6 flex justify-end">
          <Button onClick={save} disabled={saving} className="bg-[#E4572E] hover:bg-[#F27551]" data-testid="maintenance-save">
            {saving ? "Enregistrement…" : "Enregistrer"}
          </Button>
        </div>
      </DarkCard>
    </SuperadminLayout>
  );
}
